import React from "react";

import { Box, Typography } from "@material-ui/core";


const Subtitle: React.FC = () => {

    return (
        <>
            <Box>
                <Typography variant="h6" component="div">
                    Map settings
                </Typography>
            </Box>
            <Box paddingTop={1} paddingBottom={1}>
                <Typography variant="body1" component="div" color="textSecondary">
                    This will refine what is populated on the map within the footfall chapter
                </Typography>
            </Box> 
        </>
    );
};

export default Subtitle;
